import React, { Component } from 'react'
import '../Systems/Systems.css'
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap'
import SearchImg from '../../images/search.jpg'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
/**
 * this is common search control for system component
 *
 * @class Search
 * @extends {Component}
 */
class Search extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedFilter: '',
      criteria: ''
    }
    this.handleSearchOptionChange = this.handleSearchOptionChange.bind(this)
    this.onSearch = this.onSearch.bind(this)
  }
  /**
   *
   *
   * @param {*} e
   * @memberof Search
   */
  handleSearchOptionChange (e) {
    this.setState({ selectedFilter: e.target.value })
  }

  /**
   *
   *
   * @param {*} e
   * @memberof Search
   */
  handleCriteria (e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  /**
 *
 *
 * @param {*} e
 * @memberof Search
 */
  onEnterPress (e) {
    if (e.key === 'Enter') {
      this.onSearch()
    }
  }

  /**
   *
   *
   * @memberof Search
   */
  onSearch () {
    this.props.onSearch(this.state.selectedFilter, this.state.criteria)
    this.setState({ criteria: '', selectedFilter: '' })
  }

  /**
   *
   *
   * @param {*} options
   * @param {*} selectedFilter
   * @returns
   * @memberof Search
   */
  renderSearchOption (options) {
    let self = this
    return options.map(option => {
      return (
        <MenuItem eventKey={option.value}>
          <input type='radio' name={option.value} value={option.value} checked={self.state.selectedFilter === option.value} onChange={self.handleSearchOptionChange} /> {option.name}<br />
        </MenuItem>
      )
    })
  }

  /**
   *
   *
   * @returns
   * @memberof Search
   */
  render () {
    return (
      <div className='search_pos systemsSearch'>
        <div className='dropdown'>
          <ButtonToolbar>
            <DropdownButton bsStyle='default' title='' id='dropdown-no-caret'>
              <MenuItem eventKey='Brand_Name'>
                <input type='radio' name='search_all' value='' checked={!this.state.selectedFilter} onChange={this.handleSearchOptionChange} />Search all<br />
              </MenuItem>
              {this.renderSearchOption(this.props.searchOptions)}
            </DropdownButton>
          </ButtonToolbar>
        </div>
        <div className='search'>
          <input type='text' name='criteria' className='searchBox'
            value={this.state.criteria}
            onChange={this.handleCriteria.bind(this)}
            onKeyPress={this.onEnterPress.bind(this)}
          />
          <img src={SearchImg} className='searchImage' alt='Device Online' onClick={this.onSearch} />
        </div>
      </div>
    )
  }
}
export default Search



// WEBPACK FOOTER //
// ./src/components/Common/Search.js